import { MenuItem, Select } from "@mui/material";

const supplierGroupMenuItems = (supplierGroups) => {  

  return supplierGroups.map(supplierGroup => (
    <MenuItem value={supplierGroup.supplierGroupNumber.toString()}>
      {supplierGroup.supplierGroupName}
    </MenuItem>
  ));

}

function SupplierGroupSelect({supplierGroups, supplierGroupValue, changeSupplierGroupSelect}) {

  return (
    <Select
      value={supplierGroupValue}
      onChange={(e, _) => changeSupplierGroupSelect(e.target.value)}
      sx={{width: "300px"}}
    >
      {supplierGroupMenuItems(supplierGroups)}
    </Select>    
  )
}






export default SupplierGroupSelect;